import React, { useState } from 'react';
import { getTelegramChatId } from '../../services/SettingsService';

function TelegramSetupGuide({ telegramBot, onChatIdFound }) {
    const [open, setOpen] = useState(false);
    const [loading, setLoading] = useState(false);
    const [chats, setChats] = useState(null);
    const [error, setError] = useState('');

    const botLink = telegramBot ? `https://t.me/${telegramBot}` : null;

    async function handleFetch() {
        setError('');
        setLoading(true);
        setChats(null);
        try {
            const result = await getTelegramChatId();
            if (!result || result.length === 0) {
                setError('Nenhuma conversa encontrada. Certifique-se de ter enviado /start para o bot primeiro.');
            } else {
                setChats(result);
            }
        } catch (err) {
            setError('Erro ao buscar Chat IDs. O bot pode não estar configurado.');
        }
        setLoading(false);
    }

    function handleSelect(chatId) {
        if (onChatIdFound) onChatIdFound(chatId);
        setChats(null);
    }

    return (
        <div className='mb-3'>
            <button
                type='button'
                className='btn btn-sm btn-outline-secondary'
                onClick={() => setOpen(o => !o)}
            >
                {open ? '▲' : '▼'} Como configurar o Telegram?
            </button>

            {open && (
                <div className='card card-body border mt-2 p-3' style={{ fontSize: 14 }}>
                    <p className='mb-2 fw-semibold'>Siga os passos abaixo para receber alertas no Telegram:</p>
                    <ol className='ps-3 mb-3'>
                        <li className='mb-2'>
                            Abra o Telegram e procure o bot{' '}
                            {botLink
                                ? <a href={botLink} target='_blank' rel='noreferrer'><strong>@{telegramBot}</strong></a>
                                : <strong>(bot ainda não configurado pelo administrador)</strong>
                            }.
                        </li>
                        <li className='mb-2'>
                            Clique em <strong>Iniciar</strong> (ou envie <code>/start</code>) para ativar o bot.
                        </li>
                        <li className='mb-2'>
                            Clique em <strong>Buscar meu Chat ID</strong> abaixo — o sistema detecta automaticamente quem conversou com o bot.
                        </li>
                        <li className='mb-2'>
                            Selecione seu nome na lista. O campo <strong>Telegram Chat ID</strong> será preenchido automaticamente.
                        </li>
                        <li>
                            Clique em <strong>Salvar</strong> e depois em <strong>Testar Telegram</strong> para confirmar.
                        </li>
                    </ol>

                    <div className='d-flex align-items-center gap-2 flex-wrap'>
                        <button
                            type='button'
                            className='btn btn-sm btn-primary'
                            onClick={handleFetch}
                            disabled={loading || !botLink}
                        >
                            {loading ? 'Buscando...' : 'Buscar meu Chat ID'}
                        </button>
                        {!botLink && (
                            <small className='text-danger'>O bot ainda não foi configurado pelo administrador do sistema.</small>
                        )}
                    </div>

                    {error && (
                        <div className='alert alert-warning py-2 mt-2 mb-0' style={{ fontSize: 13 }}>{error}</div>
                    )}

                    {chats && chats.length > 0 && (
                        <div className='mt-2'>
                            <p className='mb-1 text-muted' style={{ fontSize: 13 }}>Selecione seu usuário:</p>
                            <div className='list-group'>
                                {chats.map(c => (
                                    <button
                                        key={c.id}
                                        type='button'
                                        className='list-group-item list-group-item-action py-2'
                                        onClick={() => handleSelect(c.id)}
                                    >
                                        <strong>{c.name}</strong>
                                        <span className='text-muted ms-2' style={{ fontSize: 12 }}>ID: {c.id}</span>
                                    </button>
                                ))}
                            </div>
                        </div>
                    )}
                </div>
            )}
        </div>
    );
}

export default TelegramSetupGuide;
